// extracted by mini-css-extract-plugin
export default {"floatingText":"rVuYP"};